/**
 * ESA Component: Register Controller
 * -------------------------------------------------------------
 * @copyright (c) 2024 [Paul Höcker|PHMG](https://phmg.online). All rights reserved.
 * @license   GNU General Public License version 3 or later
 * @version   1.0.0, 2024-01-01 00:00
 */

import Controller from "@phmg/com_hive/src/js/exports/Controller.js"

class RegisterController extends Controller {
  static CID = 'register'
  static NAME = 'Register'
  Form
  CallHandler
  FormHandler
  BS

  initiate() {
    super.initiate();

    const formElement = document.querySelector('[data-register-form]');
    if (!formElement) return;

    this.Form = formElement;
    //const FormHandlerClass = window.Hive.getFormHandler();
    this.FormHandler = window.Hive.getFormHandler(this, this.Form);

    let url = window.location.origin + '/index.php?option=com_esa&format=json';
    //const CallHandlerClass = ();
    this.CallHandler = window.Hive.getCallHandler(this, url);

    this.BS = this.utils.getBsBridge();

    // Add an event listener for com_fields
    this.FormHandler.addListener('change',
      'fieldset[data-com_esa-observe] input, fieldset[data-com_esa-observe] select, ' +
      'input[data-com_esa-observe], select[data-com_esa-observe], textarea[data-com_esa-observe]',
      () => this.observeForm())

    const timerId = this.Form.id + '.input-keyup';
    this.FormHandler.addListener('keyup',
      'input[type=text][data-com_esa-observe],textarea[data-com_esa-observe]',
      () => {
        this.utils.clearTimer(timerId);
        this.utils.addTimer(() => {
          this.observeForm();
        }, 250, timerId)
      })

    this.observeForm();

  }

  /**
   * Form observer
   */
  observeForm() {
    const formData = this.FormHandler.getData();
    formData.delete('task');
    formData.delete('option');
    formData.append('request', 'register.observe');
    this.CallHandler.postRequest('api.post',
      formData,
      (success, responseData) => {
        if (success) this.updateForm(responseData);
      })
  }

  /**
   * Update the form
   * @param data
   */
  updateForm(data) {
    let html = data['orderHtml'] || '';
    if (html) {
      this.utils.replaceElement('[data-content="order"]', html);
    }

    // handle disabled fields
    let disabled = data['disabled'] || [];
    if (disabled.length) {
      disabled.forEach((fieldId => {
        let field = document.getElementById(fieldId);
        if (field) {
          switch (field.tagName.toLowerCase()) {
            case 'fieldset' :
            case 'div' :
              this.FormHandler.disableInputGroup(`#${fieldId}`, 0);
              let container = field.querySelector('.btn-group,.switcher');
              if (container) container.classList.add('disabled');
              break;
            case 'input' :
            case 'select' :
              field.disabled = true;
              break;
            default :
              field.setAttribute('disabled', '');
              break;
          }
          let controlGroup = field.closest('.control-group,.form-group');
          if (controlGroup && controlGroup.classList.contains('collapse')) {
            this.BS('collapse.hide', controlGroup)
          }

        }
      }))
    }

    // Enable fields
    let enabled = data['enabled'] || [];
    if (enabled.length) {
      enabled.forEach((fieldId => {
        const field = document.getElementById(fieldId);
        if (field) {
          switch (field.tagName.toLowerCase()) {
            case 'fieldset' :
            case 'div' :
              this.FormHandler.enableInputGroup(`#${fieldId}`);
              let container = field.querySelector('.btn-group,.switcher');
              if (container) container.classList.remove('disabled');
              break;
            case 'input' :
            case 'select' :
              field.disabled = false;
              break;
            default :
              field.removeAttribute('disabled');
              break;
          }
          let controlGroup = field.closest('.control-group,.form-group');
          if (controlGroup && controlGroup.classList.contains('collapse')) {
            this.BS('collapse.show', controlGroup)
          }
        }
      }))
    }

  }
}

export default RegisterController
